(function (ws) {
    'use strict';
    ws.views.cartTable = ws.views.googleAnalytics.extend({

        events: {
            'click .qup-remove': 'clearFormRow',
            'click .crt-update-button': 'updateQuote',
            'click .delete': 'deleteProduct',
            'click .crt-clear-button': 'confirmClear',
            'click .qut-next-link': 'goToShipping'
        },

        /**
         * Initialize
         */
        initialize: function () {
            var _this = this;

            //initialize collection
            this.options = {
                apiUrl: this.apiUrl
            };
            this.collection = new ws.collections.cartPageCollection(this.options);

            this.$nextBtn = this.$('.crt-next-button');
            this.$rfqBtn = this.$('.crt-request-rfq');
            this.$saveBtn = this.$('.crt-save-cart');
            this.$clearCartBtn = this.$('.crt-clear-button');
            this.$emptyDiv = this.$('.crt-table-empty');
            this.$cartTotal = this.$('.crt-total-amt');
            this.$errors = this.$('.crt-cart-errors');
            this.$errorProducts = this.$('.crt-cart-error-products');
            this.$apiError = this.$('.api-error-message');
            this.$saveRfqButton = this.$('.qup-save');
            this.$spinner = this.$('.crt-spinner');
            this.$sapErrors = this.$('.crt-sap-errors');
            this.$gaTrackingId = this.$('#gaTrackingId');
            this.$zcserrors = this.$('.crt-cart-zcs-errors');
            this.$zcserrorProducts = this.$('.crt-cart-zcs-error-products');
            this.$ivperrors = this.$('.crt-cart-ivp-errors');

            //modals
            if (this.$clearModal) {
                this.confirmClearModalId = this.$clearModal.attr('id');
                this.eventAgg.on(this.confirmClearModalId + 'continue', this.clearCart, this);
            }

            this.cancelModalId = this.$('.qut-cancel-link').data('modalonconfirmation');
            this.eventAgg.on(this.cancelModalId + 'continue', this.cancelQuote, this);
            this.eventAgg.on('crt-updateCartTotal', this.updateCartTotal, this);

            this.$emptyDiv.hide();
            this.$spinner.show();
            this.collection.fetch().done(function (data) {
                this.$spinner.hide();
                if (data.allInvalidVendorProducts) {
                    $('.allInvalidVendorProducts-cart-error').removeClass('hide');
                }

                $('.comp-invalid-cont').addClass('hide');
                if (data.allInvalidVendorProducts) {
                    $('.comp-invalid-cont').removeClass('hide');
                }

                if (data.disabledVendorSalesOrgProduct && data.disabledVendorSalesOrgProduct.length) {
                    $('.error-disabledVendorSalesOrgProduct').find('.disabledVendorSalesOrgProductItems').html(data.disabledVendorSalesOrgProduct);
                    $('.error-disabledVendorSalesOrgProduct').removeClass('hide');
                }

                if (data.data !== null) {
                    // As ploy vendor popup is not required here we are uncommenting the code
                    /*if (data.polyVendorMsg === 'SapPriceingError') {
                        this.eventAgg.trigger('qut-warning-message-modal');
                    } else if (data.polyVendorMsg === 'DaPriceingError') {
                        this.eventAgg.trigger('qut-da-warning-message-modal');
                    }*/

                    if (data.data.length === 0) {
                        this.initializeDataTable();
                        this.emptyCollection();
                    } else if (data.isSapValidationMessageHasError === true) {
                        this.render(data);
                        this.showSAPerrors(data);
                    } else {
                        this.render(data);
                        if (data.onlySWPartNoError === true) {
                            this.eventAgg.trigger('openAddCartProductsModalWarning');
                        }

                        this.fireMandatoryOverlayIfNeeded(data);
                    }
                } else {
                    this.initializeDataTable();
                    this.emptyCollection();
                }

                this.$spinner.hide();

                // All products to delete on cart
                this.$productsToDelete = this.$('td.delete');
                if (data.restrictRfqModification) {
                    this.disabledButtonsAndQuantity();
                }

                if (this.cartPage === true) {
                    this.handleErrors(data);
                    this.eventAgg.trigger('updateCart');
                }
            }.bind(this)).fail(function() {
                this.$spinner.hide();
                this.initializeDataTable();
                this.emptyCollection();
                this.$apiError.show();
            }.bind(this));

            //global errors
            this.$errorMessages = $('.error-message');
            this.$cartTableErrors = $('.qap-prod-validation-error-messages');
            this.$globalErrors = $('.quf-error');

            ws.views.googleAnalytics.prototype.initialize.call(this);
            this.eventAgg.on('refreshProductCart', this.refreshQuoteCartTable, this);
            this.eventAgg.on('refreshProductCartWithOutWarning', this.refreshQuoteCartTableWithNoWarning, this);
        },

        /**
         *
         * @param {Object} data
         */
        fireMandatoryOverlayIfNeeded (data)  {
            if (data.mandatoryAssociatedProductsForm && data.mandatoryAssociatedProductsForm.hasMandatoryAssociatedProducts) {
                this.eventAgg.trigger('qutRenderRequiredProducts', data.mandatoryAssociatedProductsForm);
            } else if (data.onlySWPartNoError == true) {
                this.eventAgg.trigger('openAddCartProductsModalWarning');
            }
        },

        /**
         * Disabled the Quantity input, cancel button, Textarea to enter product, clear cart button
         */
        disabledButtonsAndQuantity: function () {
            if ($('.qup-save').length > 0) {
                this.$('.crt-clear-button').attr('disabled', true);
                this.$('.qup-qty').attr('disabled', true);
                this.$('.delete').hide();
                this.$('.qup-add-to-quote').attr('disabled', true);
                this.$('.crt-add-products').attr('disabled', true);
            }
        },

        /**
         * Show SAP erorrs
         */
        showSAPerrors: function (errors) {
            this.$sapErrors.show();

            _.each(errors.sapvalidationMessage, function (sapError) {
                this.$sapErrors.append(sapError.message);
            }.bind(this));

            this.$nextBtn.addClass('disabled').prop('disabled', true);
            this.$rfqBtn.addClass('disabled').prop('disabled', true);
            this.$saveBtn.addClass('disabled').prop('disabled', true);
        },

        /**
         * Render
         * @param {Object} data
         *
         */
        render: function (data) {

            // Added the part of DTE-28663
            if (data.accountData) {
                if ($('#multiViewEnabled').val() == 'true') {
                    this.$consolidatedViewDiv = $('.comp-consolidated-view');
                    this.consolidatedView = _.template($('#comp-quote-conversion-consolidated-data').html());
                    this.$consolidatedViewDiv.html(this.consolidatedView({accountData:data.accountData}));
                }
            }

            this.fullCollection();
            this.renderData();
            this.initializeDataTable();
            this.updateCartTotal(data.cartTotal);
            this.eventAgg.trigger('updateCart');
            this.$spinner.hide();

            if (data.opportunityNote) {
                this.renderOppertunityNote(data.opportunityNote);
            }

            if (data.msProductMessage) {
                this.showZcsErrors(data.msProductMessage);
            }
            else if (data.error) {
                this.showErrors(data.error);
            }

            if ((!this.cartPage && !data.error) && isEcomSite) {
                let gaTrackingId = this.$gaTrackingId.val();

                _.each(data.data, function(item) {
                    let productName = item.product.name;
                    let idProduct = (!_.isNull(item.product.manufacturerPart)) ? item.product.manufacturerPart : item.product.code;
                    let quantity = item.quantity;
                    let price = item.customerPriceData.value;
                    let brandName = (!_.isNull(item.product.brandName)) ? item.product.brandName : '';
                    let currencyIso = item.customerPriceData.currencyIso;
                    let categories = (!_.isNull(item.product.categories)) ? this.mapCategoryNamesToArray(item.product.categories) : '';

                    this.gtmAddToCart('quote_addtocart', productName, idProduct.toString(), quantity, price.toString(), brandName, categories, currencyIso, gaTrackingId);
                });
            }

        },

        /**
         * transform category names to mapped array to use in analytics
         * @param {string} categoryNames
         * @returns {Array}  categoryNames
         */
        mapCategoryNamesToArray: function(categoryNames) {
            return categoryNames
                    .split(',')
                    .map(categoryName => categoryName.replace(/\W/g, ''));
        },

        /**
         * Define empty collection styles
         */
        emptyCollection: function () {
            this.$table.dataTable().fnClearTable();
            this.$emptyDiv.show();
            this.$cartTotal.html('$0.00');
            this.$errorMessages.hide();

            $('.qut-next-link').on('click', function (e) {
                e.preventDefault();
            });

            this.$nextBtn.prop('disabled', true);
            this.$saveBtn.prop('disabled', true);
            this.$saveRfqButton.prop('disabled', true);
            this.$rfqBtn.prop('disabled', true);
        },

        /**
         * Define populated collection styles
         */
        fullCollection: function () {
            this.$nextBtn.removeClass('disabled').prop('disabled', false);
            this.$rfqBtn.removeClass('disabled').prop('disabled', false);
            this.$saveBtn.removeClass('disabled').prop('disabled', false);
            this.$saveRfqButton.removeClass('disabled').prop('disabled', false);
            this.$emptyDiv.hide();
        },

        /**
         * Render Table Data
         */
        renderData: function () {
            _.each(this.collection.models, function (item) {
                var tableRow = new ws.views.cartTableRow({model: item,
                    addChangeQuantity: this.TYPE_ADD_CHANGE_QUANTITY,
                    removeChangeQuantity: this.TYPE_REMOVE_CHANGE_QUANTITY,
                    removeProduct: this.TYPE_REMOVE_REMOVE_PRODUCT,
                    clearCart: this.TYPE_REMOVE_CLEAR_CART
                });
                this.$table.children('tbody').append(tableRow.render().el);
            }.bind(this));
        },

        /**
         * Initialize Data Table
         */
        initializeDataTable: function () {
            var options = {
                paging: false,
                searching: false,
                bSort: false,
                bSortable: false,
                info: false,
                responsive: {
                    details: {
                        display: $.fn.dataTable.Responsive.display.childRowImmediate
                    }
                }
            };

            if (this.responsivePriority && this.responsivePriority !== 'undefined') {
                options.columns = this.responsivePriority;
            }

            this.$table.DataTable(options);
        },

        /**
         * Refresh Quote Cart Table
         */
        refreshQuoteCartTable () {
            $('.crt-spinner').show();
            this.collection.reset();
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.collection.fetch().done(function (data) {
                if (this.collection.models.length === 0) {
                    this.initializeDataTable();
                    this.emptyCollection();
                } else {
                    if (data.isSapValidationMessageHasError === true) {
                        this.render(data);
                        this.showSAPerrors(data);
                    } else {
                        this.render(data);
                    }

                    if (data.restrictRfqModification) {
                        this.disabledButtonsAndQuantity();
                    }
                }

                if (data.onlySWPartNoError === true) {
                    this.eventAgg.trigger('openAddCartProductsModalWarning');
                }

                this.$spinner.hide();

            }.bind(this)).fail(function() {
                this.$spinner.hide();
                this.initializeDataTable();
                this.emptyCollection();
                this.$apiError.show();
            }.bind(this));
        },

        /**
         * Add products array
         * @param {Object} products
         */
        addProducts: function (products) {
            this.$errors.hide();
            this.$zcserrors.hide();
            this.$ivperrors.hide();
            this.$apiError.hide();
            this.options.products = {
                productCode: products
            };

            this.$addToCartButton.addClass('spinner-before').prop('disabled', true);
            var productsArray = new ws.models.cartTableAddProductsArray(this.options);
            var currentCollectionLength = this.emptyCollection.length;

            productsArray.save().done(function (data) {
                $('.allInvalidVendorProducts-cart-error').addClass('hide');
                if (data.allInvalidVendorProducts) {
                    $('.allInvalidVendorProducts-cart-error').removeClass('hide');
                }

                $('.comp-invalid-cont').addClass('hide');
                /*if (data.allInvalidVendorProducts) {
                    $('.comp-invalid-cont').removeClass('hide');
                }*/

                $('.error-disabledVendorSalesOrgProduct').addClass('hide');
                if (data.disabledVendorSalesOrgProduct && data.disabledVendorSalesOrgProduct.length) {
                    $('.error-disabledVendorSalesOrgProduct').find('.disabledVendorSalesOrgProductItems').html(data.disabledVendorSalesOrgProduct);
                    $('.error-disabledVendorSalesOrgProduct').removeClass('hide');
                }

                this.$addToCartButton.removeClass('spinner-before').prop('disabled', false);
                this.$addProductsQuickEntry.val('');

                if (data.msProductMessage) {
                    this.showZcsErrors(data.msProductMessage);
                }
                else if (data.error) {
                    this.showErrors(data.error);
                }

                if (data.data && data.data.length > 0) {
                    this.collection.set(data.data);

                    //if new products were added, then re-render the table
                    if (data.data.length > currentCollectionLength) {
                        this.$table.dataTable().fnClearTable();
                        this.$table.DataTable().destroy();
                        this.render(data);
                        this.$sapErrors.html('');
                        if (data.isSapValidationMessageHasError === true) {
                            this.showSAPerrors(data);
                        }
                    }

                    if (this.shoppingCartCheck) {
                        dataLayerAA.cart = {};
                        dataLayerAA.cart.category = this.cartCategory;
                        dataLayerAA.cart.type = 'add';
                        dataLayerAA.cart.action = this.cartAction;
                        dataLayerAA.product = [];

                        _.each(data.data, function(item) {
                            let product = {};
                            product.name = item.product.name;
                            product.id = (!_.isNull(item.product.manufacturerPart)) ? item.product.manufacturerPart : item.product.code;
                            product.quantity = item.quantity;
                            product.price = item.customerPriceData.value;
                            product.vendor = (!_.isNull(item.product.brandName)) ? item.product.brandName : item.product.vendorName;
                            product.category = (!_.isNull(item.product.derivedCategories)) ? item.product.derivedCategories : '';

                            dataLayerAA.product.push(product);
                        });

                        this.triggerAdobeEvent();
                    }

                    this.fireMandatoryOverlayIfNeeded(data);

                    //if on the cart page, need to trigger mini cart and show success modal
                    if (this.cartPage === true) {
                        this.eventAgg.trigger('updateCart');
                    }
                }

                this.handleErrors(data);

            }.bind(this)).fail(function() {
                this.$addToCartButton.removeClass('spinner-before').prop('disabled', false);
                this.$apiError.show();
            }.bind(this));
        },

        /**
         *  refreshing the cart table
         */
        refreshQuoteCartTableWithNoWarning() {
            $('.crt-spinner').show();
            this.collection.reset();
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.collection.fetch().done(function (data) {
                $('.allInvalidVendorProducts-cart-error').addClass('hide');
                if (data.allInvalidVendorProducts) {
                    $('.allInvalidVendorProducts-cart-error').removeClass('hide');
                }

                $('.comp-invalid-cont').addClass('hide');
                if (data.allInvalidVendorProducts) {
                    $('.comp-invalid-cont').removeClass('hide');
                }

                $('.error-disabledVendorSalesOrgProduct').addClass('hide');
                if (data.disabledVendorSalesOrgProduct && data.disabledVendorSalesOrgProduct.length) {
                    $('.error-disabledVendorSalesOrgProduct').find('.disabledVendorSalesOrgProductItems').html(data.disabledVendorSalesOrgProduct);
                    $('.error-disabledVendorSalesOrgProduct').removeClass('hide');
                }

                if (this.collection.models.length === 0) {
                    this.initializeDataTable();
                    this.emptyCollection();
                } else {
                    if (data.isSapValidationMessageHasError === true) {
                        this.render(data);
                        this.showSAPerrors(data);
                    } else {
                        this.render(data);
                    }

                    if (data.restrictRfqModification) {
                        this.disabledButtonsAndQuantity();
                    }
                }

                this.$spinner.hide();

            }.bind(this)).fail(function() {
                this.$spinner.hide();
                this.initializeDataTable();
                this.emptyCollection();
                this.$apiError.show();
            }.bind(this));
        },

        /**
         * Clear Form Row
         * @param {Object} e
         */
        clearFormRow: function (e) {
            _.each($(e.currentTarget).siblings().children(), function (item) {
                $(item).prop('value', '');
            });
        },

        /**
         * Show Error messages
         * @param {Object} errorList
         */
        handleErrors: function (errorList) {
            var $errorDiv;
            var $errorDivItems;
            this.$globalErrors.css('visibility', 'hidden');
            this.$cartTableErrors.find('.qap-sap-validation-error').hide();
            if (errorList.baseStorePhNumberList) {
                this.$restrictedNumberList.html(errorList.baseStorePhNumberList.join(', '));
            }

            $.each(errorList, function (errorType, errorValue) {
                $errorDiv = this.$cartTableErrors.find('.' + errorType);
                $errorDivItems = this.$cartTableErrors.find('.' + errorType + 'Items');

                if (_.isArray(errorValue)) {
                    if (errorValue.length) {
                        let errorString = '<ul>';
                        _.each(errorValue, function (error) {
                            errorString += '<li>' + error + '</li>';
                        });
                        errorString += '</ul>';
                        $errorDivItems.html(errorString);
                        $errorDiv.show();
                        errorString = '';
                    }
                } else if (errorValue) {
                    $errorDivItems.html(errorValue);
                    $errorDiv.show();
                }

            }.bind(this));
        },

        /**
         * Show Error messages
         * @param {Object} errors
         */
        showErrors: function (errors) {
            this.$errorProducts.html(errors);
            this.$errors.show();
        },

        /**
         * Show ZCS Error messages
         * @param {Object} errors
         */
        showZcsErrors: function (errors) {
            this.$zcserrorProducts.html(errors);
            this.$zcserrors.show();
        },

        /**
         * Update Quote
         */
        updateQuote: function () {
            this.eventAgg.trigger('updateCart');
        },

        /**
         * Update Cart Total
         * @param {Object} cartTotal
         */
        updateCartTotal: function (cartTotal) {
            this.$cartTotal.html(cartTotal);
        },

        /**
         * Delete Product
         * @param {Object} e
         */
        deleteProduct: function (e) {
            this.$errors.hide();
            var $el = $(e.currentTarget);
            var row = $el.parent();

            var id = $el.data('id');
            var partNo = $el.data('partno');
            var quantity = $el.data('quantity');
            var gaTrackingId = $el.data('gaTrackingId');
            var price = $el.data('price');
            var productName = $el.data('name');
            var brand = $el.data('brand');
            var category = $el.data('category');

            this.removeProduct(id, row, quantity, price, gaTrackingId, brand, category, productName, partNo);
        },

        /**
         * Remove product
         * @param {number} id
         * @param {Object} row
         * @param {integer} quantity
         * @param {string} price
         * @param {string} gaTrackingId
         * @param {string} brand
         * @param {Array} categories
         * @param {string} productName
         */
        removeProduct: function (id, row, quantity, price, gaTrackingId, brand, categories, productName, partNo) {
            if (!id && !row) {
                row = this.$deleteProduct.data('row');
                id = this.$deleteProduct.data('idProduct');
                productName = this.$deleteProduct.data('productName');
                quantity = this.$deleteProduct.data('quantity');
                price = this.$deleteProduct.data('price');
                gaTrackingId =  this.$deleteProduct.data('gaTrackingId');
                brand =  this.$deleteProduct.data('brand');
                categories =  this.$deleteProduct.data('category');
            }

            this.gtmRemoveFromCart(this.TYPE_REMOVE_REMOVE_PRODUCT, productName, id, quantity.toString(), price.toString(), gaTrackingId, brand, categories);

            if (location.href.indexOf('store') > -1) {
                dataLayerAA.cart = {};
                dataLayerAA.cart.category = this.cartCategory;
                dataLayerAA.product = [];
                dataLayerAA.cart.type = 'remove';
                dataLayerAA.cart.action = 'clear product';

                let product = {};
                product.name = productName;

                if (partNo) {
                    product.id = partNo;
                } else {
                    product.id = this.$deleteProduct.data('partno');
                }

                product.price = price;
                product.category = categories;
                product.vendor = brand;
                product.quantity = quantity;
                dataLayerAA.product.push(product);

                _satellite.track('event:cart');
            }

            var model = this.collection.get(id);
            model.destroy().done(function (data) {
                this.$table.dataTable().fnDeleteRow(row);
                this.updateCartTotal(data.cartTotal);
                if (this.collection.models.length === 0) {
                    this.emptyCollection();
                }

                //if on the cart page, need to trigger mini cart and show success modal
                if (this.cartPage === true) {
                    this.eventAgg.trigger('updateCart');
                }

                this.$spinner.show();
                this.eventAgg.trigger('refreshProductCartWithOutWarning');

            }.bind(this)).fail(function() {
                this.$apiError.show();
            }.bind(this));
        },

        /**
         * Launch Confirm Clear Cart Modal
         * @param {Object} e
         */
        confirmClear: function (e) {
            e.preventDefault();
            if (this.collection.models.length > 0) {
                this.eventAgg.trigger(this.confirmClearModalId);
            }
        },

        /**
         * Clear entire cart
         */
        clearCart: function () {
            this.gtmClearCart(this.TYPE_REMOVE_CLEAR_CART, this.$gaTrackingId.val(), this.$productsToDelete);

            this.$clearCartBtn.addClass('spinner-before').prop('disabled', true);
            $.get(this.clearQuoteUrl).done(function (data) {
                this.$clearCartBtn.removeClass('spinner-before').prop('disabled', false);
                if (!data.error) {
                    this.collection.reset();
                    this.eventAgg.trigger(this.confirmClearModalId + 'close');

                    if (location.href.indexOf('store') > -1) {
                        let productInfo = $('.comp-cart-table').find('td.delete');

                        dataLayerAA.cart = {};
                        dataLayerAA.cart.category = this.cartCategory;
                        dataLayerAA.product = [];
                        dataLayerAA.cart.type = 'remove';
                        dataLayerAA.cart.action = 'clear cart';

                        _.each(productInfo, function(item) {

                            let product = {};

                            product.name = $(item).data('name');
                            product.id = $(item).data('partno');
                            product.quantity = $(item).data('quantity');
                            product.price = $(item).data('price');
                            product.vendor = $(item).data('brand');
                            product.category = $(item).data('category');

                            dataLayerAA.product.push(product);
                        });

                        _satellite.track('event:cart');

                    }

                    //if on the cart page, need to trigger mini cart and show success modal
                    if (this.cartPage === true) {
                        this.eventAgg.trigger('updateCart');
                    }

                    this.emptyCollection();
                }
            }.bind(this)).fail(function() {
                this.$clearCartBtn.removeClass('spinner-before').prop('disabled', false);
                this.$apiError.show();
            }.bind(this));
        },

        /**
         * Go to Shipping Page
         * @param {Object} e
         */
        goToShipping: function (e) {
            if ($(e.currentTarget).children().attr('disabled') && $(e.currentTarget).is('a.qut-next-link')) {
                e.preventDefault();
            } else if ($(e.currentTarget).is('a.qut-next-link')) {
                this.$nextBtn.addClass('spinner-before no-padding');
                setTimeout(function () {
                    this.$nextBtn.prop('disabled', true);
                }.bind(this), 0);
                window.location.href = $(e.currentTarget).attr('href');
            }
        }
    });
})(westcon);
